// Import actions
import { scheduleNpvrRecording, fetchNpvrRecordings } from 'store/actions';

// Import hooks
import { useAppSelector, useAppDispatch } from 'store/hooks';

export const useProgramRecordings = (programId) => {
	const dispatch = useAppDispatch();
	const { data: recordingsNpvr, isLoaded: areNpvrRecordingsLoaded } = useAppSelector(({ recordingsNpvr }) => recordingsNpvr);

	const handleScheduleNpvrRecordings = () => {
		scheduleNpvrRecording(programId, () => fetchNpvrRecordings()(dispatch))(dispatch);
	};

	const isNpvrProgramRecorded = recordingsNpvr.find(({ program_uuid }) => program_uuid === programId);

	return {
		scheduleNpvrRecordings: handleScheduleNpvrRecordings,
		isLoading: !areNpvrRecordingsLoaded,
		isRecorded: isNpvrProgramRecorded
	};
};
